import { UiComponentConfigType } from 'lib/interfaces/ui-components';

export enum ValidationError {
  LogicRuleInvalid = 'logic-rule-invalid',
  ParentMissingChildren = 'missing-children',
  TransitionActionMissingErrorStep = 'missing-workflow-error-step-name',
  TransitionInvalid = 'invalid-transition',
}

export type ComponentValidationError = {
  type: ValidationError;
  componentType: UiComponentConfigType;
  stepName: string;
  message: string;
};

export type ComponentValidationErrorsMap = Record<string, ComponentValidationError[]>;
